import { z } from "zod";

export const dietrySchema = z.object({
  day: z.string().optional(),
  morning_meal_fast: z.string().optional(),
  morning_meal_fast_time: z.string().optional(),
  lunch: z.string().optional(),
  lunch_time: z.string().optional(),
  evening_snacks: z.string().optional(),
  evening_snacks_time: z.string().optional(),
  dinner: z.string().optional(),
  dinner_time: z.string().optional(),
  anything_between: z.string().optional(),
  anything_between_time: z.string().optional(),
});

export type dietrydata = z.infer<typeof dietrySchema>;

export const EditDietSchema = dietrySchema.partial();

export type EditDietFormValues = z.infer<typeof EditDietSchema>;
